var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4444 1H2.11111C1.49746 1 1 1.49746 1 2.11111V19.8889C1 20.5025 1.49746 21 2.11111 21H15.4444C16.0581 21 16.5556 20.5025 16.5556 19.8889V2.11111C16.5556 1.49746 16.0581 1 15.4444 1Z",
    stroke: "#38cb89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fcfffd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77774 17.6675C9.39139 17.6675 9.88885 17.1701 9.88885 16.5564C9.88885 15.9428 9.39139 15.4453 8.77774 15.4453C8.16409 15.4453 7.66663 15.9428 7.66663 16.5564C7.66663 17.1701 8.16409 17.6675 8.77774 17.6675Z",
    stroke: "#38cb89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fcfffd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppScreen);
export default __webpack_public_path__ + "static/media/app-screen.54d0c6a797fc3df8e346a7e1c0f80661.svg";
export { ForwardRef as ReactComponent };